/**
 * @file Converts a cent amount to its dollar value.
 */
const CENTS_IN_DOLLAR = 100;

/**
 * Converts a cent amount to its dollar value.
 */
const getFormattedAmountValue = (value: number): number => {
  const amount = value / CENTS_IN_DOLLAR;

  return amount;
};

export default getFormattedAmountValue;
